export default __webpack_public_path__ + "static/media/product2.bc83a17b.webp";